import React, { useEffect, useRef, useState } from 'react';
import dianShang1 from 'images/industry-dian-shang1.png';
import dianShang2 from 'images/industry-dian-shang2.png';
import dianShangTool1 from 'images/industry-dian-shang-tool1.png';
import dianShangTool2 from 'images/industry-dian-shang-tool2.png';
import jiaoTong1 from 'images/industry-jiao-tong1.png';
import jiaoTong2 from 'images/industry-jiao-tong2.png';
import jiaoTongTool1 from 'images/industry-jiao-tong-tool1.png';
import hunShe1 from 'images/industry-hun-she1.png';
import hunShe2 from 'images/industry-hun-she2.png';
import hunShe3 from 'images/industry-hun-she3.png';
import hunSheTool1 from 'images/industry-hun-she-tool1.png';
import bendi1 from 'images/industry-ben-di1.png';
import bendi2 from 'images/industry-ben-di2.png';
import canting from 'images/industry-ben-di-icon-canting.png';
import weibomendian from 'images/industry-ben-di-icon-weibomendian.png';
import xiongmao from 'images/industry-ben-di-icon-xiongmao.png';
import jiaju1 from 'images/industry-jiaju1.jpg';
import jiaju2 from 'images/industry-jiaju2.jpeg';
import dajiankang1 from 'images/industry-dajiankang1.png';
import dajiankang2 from 'images/industry-dajiankang02.png';
import jianf from 'images/industry-jiankang-jianf.png';
import zhuanhb from 'images/industry-jiankang-zhuanhb.png';
import xiaoxin from 'images/industry-ben-di-icon-xiaoxin.png';
import aizhihui from 'images/industry-ben-di-icon-aizhihui.png';
// import lizitong from 'images/industry-ben-di-icon-lizitong.png';
import line from 'images/industry-line.png';
import Tool from 'pages/index/Tool';

const industryList = [
  {
    industry: '电商',
    name: '私域产品',
    desc: '多种应用产品，一键部署，为私域电商打造一站式解决方案。小程序/H5购物直达，高效沉淀粉丝，为私域蓄水。精细化社群运营，助力长效转化，轻松卖货。',
    pathList: ['广告\n直购', { text: '加粉沉淀', sub: '仅在小程序' }, '企微\n导购', '社区\n运营', '复购\n引导'],
    tools: [
      {
        icon: dianShangTool1,
        name: '枫页小店',
        url: 'https://wj.qq.com/s2/8229486/11e1/',
        track: 'link-feng-ye',
        // clientId: '123' todo 可能以后要加 clientId
      },
      {
        icon: dianShangTool2,
        name: '鱼塘智能转粉',
        url: '/application/1111312646',
        track: 'link-yu-tang',
      },
    ],
    imgList: [dianShang1, dianShang2],
  },
  {
    industry: '交通',
    name: '车讯达',
    desc: '以小程序为载体，建立联络全域流量的智能集客营销平台。提供直联终端门店产品能力，将线索进行初步分级，同时更及时高效地触达线下门店销售顾问，从而形成1对1的高效互动。帮助车企构建长效拓客能力。',
    pathList: ['流量\n引流', '线索\n收集', '线索\n处理', '线索\n培育', '成交\n转化'],
    tools: [
      {
        icon: jiaoTongTool1,
        name: '腾讯车讯达',
        url: 'https://wj.qq.com/s2/8221588/18fd/',
        track: 'link-che-xun-da',
      },
    ],
    imgList: [jiaoTong1, jiaoTong2],
  },
  {
    industry: '婚摄',
    name: '线索管理平台',
    desc: '以线索通为载体，串联多款应用产品，为婚纱摄影等行业打造全链路客资高效转化组合方案。通过对公众号/小程序粉丝等客户线索的管理运营、归因分析以及标签策略优化，实现线索收集-运营-分析-应用的一站式管理，帮助婚摄客户在生意全链路降本增效。',
    pathList: ['智能\n挖客', '客资\n管理', '线索\n归因', '建模\n优化', '投放\n提效'],
    tools: [
      {
        icon: hunSheTool1,
        name: '腾讯线索通平台',
        url: 'https://leads.qq.com/',
        track: 'link-leads',
      },
      {
        icon: 'https://union.gdtimg.com/webstore/fb14a18a-440b-439f-82ae-91e673676743.png',
        name: '云雀客服工具',
        url: '/application/1110111308',
        track: 'link-yunque',
      },
      {
        icon: 'https://union.gdtimg.com/webstore/ff10237c-e569-49ae-9d8b-0f1c34df9099.png',
        name: '樱桃云CRM工具',
        url: '/application/1111925292',
        track: 'link-yintao',
      },
    ],
    imgList: [hunShe1, hunShe2, hunShe3],
  },
  {
    industry: '本地',
    name: '本地化广告链路',
    desc: '聚焦本地日常生活需求与服务消费场景，以附近推广告及常规广告为载体，搭配小程序/公众号/表单/企微加粉链路，餐饮行业客户可进行优惠券派发及快速核销，并针对门店外卖/收银/私域运营等系统进行统一管理；家政行业客户可进行意向客资快速分派及订单预约跟进。满足本地类商家小预算/低成本、快速转化/引流到店等营销诉求。',
    pathList: ['广告\n引流', '客户留资/\n卡券领取', '线索培育/\n社群运营', '预约付费/\n卡券核销', '投放\n提效'],
    tools: [
      {
        icon: xiongmao,
        name: '熊猫家政系统',
        url: '/application/0000000014',
        track: 'link-panda',
      },
      {
        icon: weibomendian,
        name: '微播门店管理系统',
        url: '/application/0000000015',
        track: 'link-wei-bo-men-dian',
      },
      {
        icon: canting,
        name: '微盟智慧餐厅系统',
        url: '/application/0000000013',
        track: 'link-can-ting',
      },
    ],
    imgList: [bendi1, bendi2],
  },
  {
    industry: '家居',
    name: '全链路数字营销体系',
    desc: '聚焦家居行业全链路数字化升级，公众号智能客服&企微工具将公域与私域有效结合，搭配小程序轻量化留资，提升广告投放效率的同时，提高客资管理效率；scrm系统同时助力客户数据资产沉淀，促成全链路数据可视化/闭环串联的效果，帮助家居行业客户广告投放降本增效。',
    pathList: ['智能\n转化', '客资\n管理', '长效\n转化', '数据\n沉淀', '反哺\n投放'],
    tools: [
      {
        icon: hunSheTool1,
        name: '腾讯线索通平台',
        url: 'https://leads.qq.com/',
        track: 'link-xian-suo-tong',
      },
      {
        icon: xiaoxin,
        name: '小芯AI客服',
        url: '/application/1112004705',
        track: 'link-xiao-xin',
      },
      {
        icon: aizhihui,
        name: 'AI智慧客服',
        url: '/application/1111751131',
        track: 'link-ai-zhi-hui',
      },
      // {
      //   icon: lizitong,
      //   name: '栗子通智能落地页',
      //   url: '/application/1110773732',
      //   track: 'link-li-zi-tong',
      // },
    ],
    imgList: [jiaju1, jiaju2],
  },
  {
    industry: '大健康',
    name: '企微营销链路',
    desc: '聚焦医药行业获客数字化管理场景，将线上获客-私域运营-数字化管理有效结合，为客户提供更短线索转化路径，降低转化成本。配合企微工具，流程化、标签化管理线索，提升管理效率；提供全链路数据归因模型，深度优化，反哺获客，提升下单转化率。',
    pathList: ['广告\n获客', '企微\n开口', '获取关\n键意向', '下单\n转化', '持续\n复购'],
    tools: [
      {
        icon: jianf,
        name: '尘锋',
        url: '/application/1112002614',
        track: 'link-jianfeng',
      },
      {
        icon: zhuanhb,
        name: '转化宝',
        url: 'https://zhb.qq.com/',
        track: 'link-zhuan-hua-bao',
      },
    ],
    imgList: [dajiankang1, dajiankang2],
  },
];

const Industries: React.FC = () => {
  const [current, setCurrent] = useState<number>(0);
  const [left, setLeft] = useState<number>();
  const tabsRef = useRef<HTMLDivElement>();
  const [top, setTop] = useState<number>();
  const contentRef = useRef<HTMLDivElement>();

  const { imgList } = industryList[current];

  useEffect(() => {
    const { left: containerLeft } = tabsRef.current.getBoundingClientRect();
    const { left, width } = tabsRef.current.querySelector('.active').getBoundingClientRect();
    setLeft(left - containerLeft + width / 2 - 8);
  }, [current]);

  useEffect(() => {
    const handleScroll = () => {
      const { top } = contentRef.current.getBoundingClientRect();
      if (top <= window.innerHeight) {
        setTop((top - window.innerHeight) / 4);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <section className="industries-header">
        <div className="fade text-bold header">行业解决方案</div>
        <div className="fade text-bold sub-header">SOLUTIONS</div>

        <div className="fade tabs" ref={tabsRef}>
          {industryList?.map(({ industry }, index) => (
            <span
              key={industry}
              className={`text-bold tab ${index === current ? 'active' : ''}`}
              role="button"
              onMouseEnter={() => setCurrent(index)}
            >
              {industry}
            </span>
          ))}
          <span className="indicator" style={{ left }} />
        </div>
      </section>

      <section className="industries-content" ref={contentRef}>
        <div className="fade flex-list">
          {industryList?.map(({ name, desc, pathList, tools }, index) => (
            <div key={index} className="industry" style={{ transform: `translateX(-${current * 100}%)` }}>
              <div className="text-bold name">{name}</div>
              <div className="text-desc">{desc}</div>
              <div className="path-list">
                {(pathList as (string | { text: string; sub: string })[]).map((path, index) => (
                  <div key={index} className="text-bold path-wrapper">
                    <span className="path">
                      {typeof path === 'string' ? (
                        path
                      ) : (
                        <>
                          {path.text}
                          <small>{path.sub}</small>
                        </>
                      )}
                    </span>
                  </div>
                ))}
              </div>
              {tools?.length > 0 ? (
                <>
                  <div className="text-bold title">链路工具</div>
                  <div className="tools">
                    {tools.map((tool) => (
                      <Tool key={tool.name} {...tool} />
                    ))}
                  </div>
                </>
              ) : (
                <a
                  href="https://wj.qq.com/s2/8229421/22dc/"
                  className="a-button large"
                  target="_blank"
                  rel="noreferrer"
                  data-track="link-industry-contact"
                >
                  联系我们
                </a>
              )}
            </div>
          ))}
        </div>

        <img src={line} alt="" className="line top" style={{ transform: `translateY(${top}px)` }} />
        <img src={line} alt="" className="line bottom" style={{ transform: `translateY(${-top}px)` }} />

        {imgList.length === 2 && (
          <>
            <img
              key={imgList[0]}
              src={imgList[0]}
              alt=""
              className="pic left"
              style={{ transform: `translateY(${top}px)` }}
            />
            <img
              key={imgList[1]}
              src={imgList[1]}
              alt=""
              className="pic right"
              style={{ transform: `translateY(${top}px)` }}
            />
          </>
        )}
        {imgList.length === 3 && (
          <div className="pic-wrapper">
            <img src={imgList[0]} alt="" />
            <img src={imgList[1]} alt="" />
            <img src={imgList[2]} alt="" />
          </div>
        )}
      </section>
    </>
  );
};

export default Industries;
